import React, { useState } from 'react';

const ReceivedTab = ({ 
  gifts, 
  couple, 
  loading,
  loadingReceived,
  onExportPDF,
  onSendThankYou,
  formatPrice,
  receivedTopRef
}) => {
  // Estados internos
  const [searchQuery, setSearchQuery] = useState('');
  const [visibleCount, setVisibleCount] = useState(12);

  const [sortBy, setSortBy] = useState('newest'); // ✅ Nuevo estado

  // Calcular regalos recibidos
  const receivedGifts = gifts.filter(g => (g.amountReceived || 0) > 0);

  // Filtrar por búsqueda
  const receivedGiftsFiltered = searchQuery
    ? receivedGifts.filter(gift =>
        gift.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        gift.contributors?.some(c =>
          c.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          c.email?.toLowerCase().includes(searchQuery.toLowerCase())
        )
      )
    : receivedGifts;

    // ✅ Ordenar según selección
  const receivedGiftsSorted = [...receivedGiftsFiltered].sort((a, b) => {
    // Obtener fecha del último aporte
    // const getLastDate = (gift) => {
    //   const lastContributor = gift.contributors?.[gift.contributors.length - 1];
    //   return lastContributor?.date ? new Date(lastContributor.date) : new Date(0);
    // };
const getLastDate = (gift) => {
  const dates = (gift.contributors || [])
    .map(c => c?.date ? new Date(c.date).getTime() : 0);
  return new Date(Math.max(0, ...dates));
};

    switch (sortBy) {
      case 'newest':
        return getLastDate(b) - getLastDate(a);
      case 'oldest':
        return getLastDate(a) - getLastDate(b);
      case 'highest':
        return (b.amountReceived || 0) - (a.amountReceived || 0);
      case 'lowest':
        return (a.amountReceived || 0) - (b.amountReceived || 0);
      default:
        return 0;
    }
  });


  return (
    <div className="space-y-6 animate-fade-in">
      <div ref={receivedTopRef} />

      {/* Header con búsqueda y export */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <h2 className="text-xl sm:text-2xl font-display font-bold text-neutral-900">
          Regalos Recibidos
        </h2>

        <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
          {/* Search bar */}
          <div className="relative w-full sm:w-64">
            <input
              type="text"
              placeholder="Buscar por nombre o email..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent-500"
            />
            <svg
              className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>

          {/* Export PDF */}
          {gifts.filter((g) => (g.amountReceived || 0) > 0).length > 0 && (
            <button
              onClick={onExportPDF}
              className="w-full sm:w-auto px-4 py-2 bg-accent-500 text-white rounded-lg hover:bg-accent-600 transition-colors font-medium whitespace-nowrap"
            >
              📄 Exportar PDF
            </button>
          )}
        </div>
      </div>

       {/* ✅ Contador, Sort y limpiar búsqueda */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="px-4 py-2 rounded-full bg-accent-100 text-accent-700 font-semibold">
            {receivedGifts.length} regalo{receivedGifts.length === 1 ? '' : 's'}
          </span>

          {searchQuery && (
            <button
              onClick={() => setSearchQuery('')}
              className="text-sm text-neutral-600 hover:text-neutral-800"
            >
              Limpiar búsqueda
            </button>
          )}
        </div>

        {/* ✅ Sort selector */}
        {receivedGifts.length > 1 && (
          <div className="flex items-center gap-2">
            <label className="text-sm text-neutral-600">Ordenar:</label>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="px-3 py-2 border border-neutral-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-accent-500 bg-white"
            >
              <option value="newest">Más recientes</option>
              <option value="oldest">Más antiguos</option>
              <option value="highest">Mayor monto</option>
              <option value="lowest">Menor monto</option>
            </select>
          </div>
        )}
      </div>

      {/* Loading state */}
      {loadingReceived || loading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent-500" />
        </div>
      ) : receivedGiftsFiltered.length === 0 ? (
        /* Empty state */
        <div className="card p-12 text-center">
          <div className="text-6xl mb-4">🎁</div>
          <h3 className="text-xl font-semibold text-neutral-900 mb-2">
            {searchQuery ? 'No se encontraron resultados' : 'Aún no recibiste regalos'}
          </h3>
          <p className="text-neutral-600">
            {searchQuery
              ? `No encontramos coincidencias para "${searchQuery}".`
              : 'Cuando alguien elija un regalo de tu lista, aparecerá acá.'}
          </p>
        </div>
      ) : (
        /* Gifts list */
        <>
          <div className="grid gap-6">
            {/* {receivedGiftsFiltered.slice(0, visibleCount).map((gift) => { */}
{receivedGiftsSorted.slice(0, visibleCount).map((gift) => {

              const progress = ((gift.amountReceived || 0) / gift.price) * 100;
              const isCompleted = progress >= 100;
              const hasMultipleContributors = (gift.contributors?.length || 0) > 1;
              const remaining = Math.max(0, gift.price - (gift.amountReceived || 0));

              return (
                <div key={gift.id} className="card p-6">
                  {/* Gift header */}
                  <div className="flex items-start justify-between gap-4 mb-4">
                    <div className="flex-1">
                      <h3 className="text-xl font-display font-semibold text-neutral-900 mb-1">
                        {gift.name}
                      </h3>
                      <p className="text-sm text-neutral-500">
                        Precio: {formatPrice(gift.price)}
                      </p>
                    </div>

                    <div
                      className={`px-3 py-1 rounded-full text-sm font-semibold ${
                        isCompleted
                          ? 'bg-green-100 text-green-700'
                          : 'bg-amber-100 text-amber-700'
                      }`}
                    >
                      {isCompleted ? '✓ Completado' : `${Math.round(progress)}%`}
                    </div>
                  </div>

                  {/* Progress bar */}
                  {!isCompleted && (
                    <div className="mb-4">
                      <div className="w-full h-2 bg-neutral-200 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-gradient-to-r from-accent-500 to-accent-600 transition-all duration-500"
                          style={{ width: `${Math.min(progress, 100)}%` }}
                        />
                      </div>
                      <div className="flex items-center justify-between mt-2 text-sm">
                        <span className="text-neutral-600">
                          Recibido: {formatPrice(gift.amountReceived || 0)}
                        </span>
                        <span className="text-neutral-600">
                          Faltan: {formatPrice(remaining)}
                        </span>
                      </div>
                    </div>
                  )}

                  {/* Contributors list */}
                  {gift.contributors && gift.contributors.length > 0 && (
                    <div className="mb-4">
                      <p className="text-sm font-medium text-neutral-700 mb-2">
                        {hasMultipleContributors
                          ? `Aportes recibidos (${gift.contributors.length}):`
                          : 'Aporte recibido:'}
                      </p>

                      <div className="space-y-2">
                        {gift.contributors.map((contributor, idx) => (
                          <div key={idx}>
                            <div className="bg-neutral-50 rounded-lg p-3">
                              <div className="flex items-center justify-between mb-2">
                                <div className="flex-1">
                                  <p className="font-medium text-neutral-900">
                                    {contributor.name}
                                  </p>
                                  <p className="text-xs text-neutral-500">
                                    {contributor.email}
                                  </p>
                                  {contributor.phone && (
                                    <p className="text-xs text-neutral-500">
                                      {contributor.phone}
                                    </p>
                                  )}
                                </div>
                                <div className="text-right">
                                  <p className="font-semibold text-accent-600">
                                    {formatPrice(contributor.amount)}
                                  </p>
                                  <p className="text-xs text-neutral-500">
                                    {new Date(contributor.date).toLocaleDateString('es-AR', {
                                      day: 'numeric',
                                      month: 'short',
                                    })}
                                  </p>
                                </div>
                              </div>

                              {/* Actions row */}
                              <div className="mt-2 pt-2 border-t border-neutral-200 flex items-center justify-between">
                                {/* Comprobante */}
                                {contributor.receiptUrl ? (
                                  <a
                                    href={contributor.receiptUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-xs text-blue-600 hover:text-blue-700 font-medium"
                                  >
                                    📎 Ver comprobante
                                  </a>
                                ) : (
                                  <span className="text-xs text-neutral-400">Sin comprobante</span>
                                )}

                                {/* Agradecimiento */}
                                {contributor.thanked ? (
                                  <div className="flex items-center gap-2">
                                    <span className="text-xs text-green-600 font-medium">
                                      ✓ Agradecido
                                    </span>
                                    <button
                                      onClick={() => onSendThankYou(gift, contributor)}
                                      className="text-xs text-neutral-500 hover:text-accent-600"
                                      title="Enviar de nuevo"
                                    >
                                      ↻
                                    </button>
                                  </div>
                                ) : (
                                  <button
                                    onClick={() => onSendThankYou(gift, contributor)}
                                    className="text-xs text-accent-600 hover:text-accent-700 font-semibold"
                                  >
                                    ✉️ Agradecer
                                  </button>
                                )}
                              </div>
                            </div>

                            {contributor.message && (
                              <div className="mt-2 ml-3 bg-primary-50 border-l-2 border-primary-300 rounded-r-lg p-3">
                                <p className="text-sm text-neutral-700 italic">
                                  "{contributor.message}"
                                </p>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Load more button */}
          {/* {visibleCount < receivedGiftsFiltered.length && ( */}
{visibleCount < receivedGiftsSorted.length && (

            <div className="flex justify-center pt-4">
              <button
                type="button"
                onClick={() => setVisibleCount((v) => v + 12)}
                className="btn-secondary px-6 py-3 text-base"
              >
                Mostrar 12 más
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ReceivedTab;